var getMultiSelectTheme = theme => ({
  colors: {
    border: {
      initial: theme.colors.ultraViolets[20],
      focus: theme.colors.ultraViolets[70]
    },
    option: {
      initial: theme.colors.greys[80],
      selected: theme.colors.ultraViolets[70]
    },
    optionBackground: {
      hover: theme.colors.ultraViolets[10],
      selected: theme.colors.ultraViolets[10]
    }
  }
});
export { getMultiSelectTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXVsdGlTZWxlY3QuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
